import { FC } from "react";
import { useTranslation } from "react-i18next";

import { TextboxTemplate } from "@ryde/controls";

import { BulkPassengerNearbySearchFormFieldsEnum } from "./models";

export const BulkPassengerNearbySearchForm: FC = () => {
  const { t } = useTranslation();

  return (
    <TextboxTemplate
      name={BulkPassengerNearbySearchFormFieldsEnum.distanceInMeters}
      labelTranslated={t(
        `passenger.formLabel.${BulkPassengerNearbySearchFormFieldsEnum.distanceInMeters}`,
      )}
    />
  );
};
